import { inject, Pipe, PipeTransform } from '@angular/core';
import { OrganizationsStore } from '../store/organizations.store';

@Pipe({
  name: 'organizationName',
})
export class OrganizationNamePipe implements PipeTransform {
  private organizationsStore = inject(OrganizationsStore);

  transform(organizationId: string): string | null {
    return this.organizationsStore.entities()[organizationId]?.data?.name ?? null;
  }
}
